<script setup lang="ts">
import { withDefaults } from 'vue'
import StatusIndicator from 'Common/components/elements/feedback/StatusIndicator.vue'
import { statusColorsMap } from 'Modules/constants/statusColorMap'
interface PropTypes {
  status: string
}

withDefaults(defineProps<PropTypes>(), {
  status: 'Not Started',
})
</script>

<template>
  <StatusIndicator :color="statusColorsMap[status]">
    {{ status }}
  </StatusIndicator>
</template>
